import { useMemo } from 'react';
import { assert, keyBy } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ThreadListLoader } from './threadListInterface';
import { ThreadItemAggregate } from '../item/threadItemModel';

export function createThreadListLoader(
    config: ReportingShellLoaderBaseConfig
): ThreadListLoader {
    const { repository } = config;

    return {
        useLoad(context, props) {
            const integrationQuery = repository.platform.integration.useFind(
                context,
                { workspace: context.workspace.id },
                {
                    suspense: true,
                }
            );

            const definitionQuery = repository.platform.integrationDefinition.useFind(
                context,
                {},
                {
                    suspense: true,
                }
            );

            assert(integrationQuery.status === 'success', `expected suspense`);
            assert(definitionQuery.status === 'success', `expected suspense`);

            const items = useMemo(() => {
                if (!integrationQuery.data || !definitionQuery.data) {
                    return [];
                }

                // Create a lookup map for efficient definition matching
                const definitionMap = keyBy(definitionQuery.data, 'id');

                // Transform integrations to aggregates
                const aggregates: ThreadItemAggregate[] = [];
                for (const integration of integrationQuery.data) {
                    const definition = definitionMap[integration.definition_id];
                    if (definition) {
                        aggregates.push({
                            integration,
                            definition,
                        });
                    }
                }

                return aggregates;
            }, [integrationQuery.data, definitionQuery.data]);

            return {
                items,
            };
        },
    };
}
